module.exports = __webpack_public_path__ + "media/list2.ee278c23.mp4";